module.exports = __webpack_public_path__ + "img/Linux Knowledge Today_Silicon Stone Education_20200905.79f4f7f9.jpg";